// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__NZKjR","tableWrapper":"Table_tableWrapper__KmxxD","type-border":"Table_type-border___l2Mi"};